import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';

    angular.module('dashboard').controller('DepositorCtrl', DepositorCtrl);

    DepositorCtrl.$inject = [
        '$rootScope',
        'AUTH_EVENTS',
        '$scope',
        '$state',
        '$translate',
        '$cookies',
        '$sessionStorage',
        'uiGridConstants',
        'dateFilter',
        'API_CONFIG',
        'XSRF_TOKEN',
        'DepositorFilter',
        'DepositorService',
    ];

    function DepositorCtrl(
        $rootScope,
        AUTH_EVENTS,
        $scope,
        $state,
        $translate,
        $cookies,
        $sessionStorage,
        uiGridConstants,
        dateFilter,
        API_CONFIG,
        XSRF_TOKEN,
        DepositorFilter,
        DepositorService
    ) {
        const csrf = $cookies.get(XSRF_TOKEN);
        $scope.criteria = new DepositorFilter();
        $scope.criteriaStringify = JSON.stringify($scope.criteria);
        $scope.exportCsvUrl = API_CONFIG.url + '/v1/depositor/csv-export?_csrf=' + csrf;
        $scope.selectedItems = 'ok';

        var columnFieldMap = [
            { field: 'creationTime', property: 'created' },
            { field: 'email', property: 'email' },
            { field: 'name', property: 'name' },
            { field: 'antispamDate', property: 'antispamDate' },
            { field: 'confirmNotif', property: 'confirmDate' },
            { field: 'emailNotif', property: 'replyAddress' },
            { field: 'spammer', property: 'status' },
        ];

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="depositor_details({depositorId : row.entity.depositorId, tabName : \'full\'})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var spamCellTemplate =
            '<a class="grid-cell-link" ui-sref="depositor_details({depositorId : row.entity.depositorId, tabName : \'full\'})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{(row.entity.spammer ? "YES" : "NO")|translate }}</div></a>';
        $scope.gridOptions = {
            columnDefs: [
                {
                    name: 'creationTime',
                    displayName: 'Date création',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                },
                { name: 'email', displayName: 'Email', cellTemplate: defaultCellTemplate },
                { name: 'name', displayName: 'Raison sociale', cellTemplate: defaultCellTemplate },
                {
                    name: 'antispamDate',
                    displayName: 'Notification 1er envoi',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                },
                {
                    name: 'confirmNotif',
                    displayName: 'Confirmé le',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                },
                { name: 'emailNotif', displayName: 'Email Notification', cellTemplate: defaultCellTemplate },
                { name: 'spammer', displayName: 'SPAM', cellTemplate: spamCellTemplate, enableSorting: false },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            enableRowSelection: true,
            enableSelectAll: true,
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: function (gridApi) {
                $scope.gridApi = gridApi;

                // Sorting & pagination
                $scope.gridApi.core.on.sortChanged($scope, sortChanged);
                $scope.gridApi.pagination.on.paginationChanged($scope, paginationChanged);
            },
            rowHeight: 30,
        };

        $scope.searchDepositors = function () {
            $scope.criteriaStringify = JSON.stringify($scope.criteria);
            $sessionStorage.depositorHistorySearchCriteria = new DepositorFilter($scope.criteria);
            $scope.prom = DepositorService.search($scope.criteria);
            $scope.depositorPromise = $scope.prom.$promise;
            $scope.prom.$promise.then(function (data) {
                if (data.content) {
                    $scope.gridOptions.data = data.content;
                    $scope.gridOptions.totalItems = data.totalElements;
                } else {
                    $scope.gridOptions.data = [];
                    $scope.gridOptions.totalItems = 0;
                }
            });
        };

        function sortChanged(grid, sortColumns) {
            sortColumns = _.map(sortColumns, convertSort);
            if (sortColumns && sortColumns.length > 0) {
                $scope.criteria.setSort(sortColumns);
            } else {
                $scope.criteria.resetSort();
            }
            $scope.searchDepositors();
            $scope.criteriaStringify = JSON.stringify($scope.criteria);
            $scope.gridApi.selection.clearSelectedRows();
        }

        function convertSort(col) {
            var columnField = _.find(columnFieldMap, { field: col.field });
            if (col && col.sort) {
                return {
                    direction: angular.uppercase(col.sort.direction),
                    property: columnField ? columnField.property : col.field,
                    priority: col.sort.priority,
                };
            }
            return {};
        }

        function convertSortInverseName(col) {
            var columnField = _.find(columnFieldMap, { property: col.property });
            return columnField ? columnField.field : col.property;
        }

        function paginationChanged(page, size) {
            $scope.criteria.setPageSize(size);
            $scope.criteria.setPage(page - 1);
            $scope.searchDepositors();
        }

        $scope.initCriterias = function initCriterias() {
            $scope.criteria.scope = 'EPDF';
            $scope.criteria.creationTimeFrom = new Date();
            $scope.criteria.creationTimeTo = new Date();
            $scope.criteria.antispamDateFrom = undefined;
            $scope.criteria.antispamDateTo = undefined;
            $scope.criteria.confirmNotifFrom = undefined;
            $scope.criteria.confirmNotifTo = undefined;
            $scope.criteria.spammer = undefined;
            $scope.criteria.emailNotif = undefined;
            $scope.criteria.name = undefined;
            $scope.criteria.email = undefined;
        };

        ////////////////
        activate();

        function activate() {
            $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
                $sessionStorage.depositorHistorySearchCriteria = undefined;
            });
            if ($sessionStorage.depositorHistorySearchCriteria) {
                $scope.criteria = new DepositorFilter($sessionStorage.depositorHistorySearchCriteria);
            } else {
                $scope.initCriterias();
            }
            if ($scope.criteria.pageCriteria.sorts) {
                for (var i = 0; i < $scope.gridOptions.columnDefs.length; i++) {
                    if (
                        $scope.gridOptions.columnDefs[i].name ===
                        convertSortInverseName($scope.criteria.pageCriteria.sorts[0])
                    ) {
                        $scope.gridOptions.columnDefs[i].sort = {
                            direction: angular.lowercase($scope.criteria.pageCriteria.sorts[0].direction),
                            priority: 0,
                        };
                        break;
                    }
                }
            }
            $scope.searchDepositors();
        }

        $scope.clearCriterias = function () {
            $scope.initCriterias();
            $sessionStorage.depositorHistorySearchCriteria = new DepositorFilter($scope.criteria);
            $scope.searchDepositors();
        };

        $scope.getGridHeight = function () {
            var rowHeight = 30;
            return {
                height: $scope.gridApi.core.getVisibleRows($scope.gridApi.grid).length * rowHeight + 81 + 'px',
            };
        };

        // Indique si l'export CSV de la grille peut être réalisé
        $scope.canExportGrid = function () {
            if ($scope.gridApi && $scope.gridApi.selection) {
                return $scope.gridApi.selection.getSelectedRows().length > 0;
            }
            return false;
        };

        $scope.getDepositorIdsSelected = function () {
            var ids = [];
            if ($scope.gridApi && $scope.gridApi.selection) {
                var selectedRows = $scope.gridApi.selection.getSelectedRows();
                for (var i = 0; i < selectedRows.length; i++) {
                    ids += selectedRows[i].depositorId + ',';
                }
            }
            return ids;
        };
    }
})();
